$(() => {
  // Show Special Offer modal
  $('.show-special-toggle').on('click', () => {
    $('#show_special_modal_container').removeClass('hidden');
  });

  // Clear form after submitting
  $(() => {
    $('#new_claim').bind('ajax:complete', () => {
      $('#claim_name').val('');
      $('#claim_email').val('');
      $('#claim_message').val('');
      $('#claim-listing-upload').val('');
      $('.modal-images-preview-wrapper.claim-listing').html('');
    });
  });
});
